<template>

  <div>
    <b-row>
      <b-col lg="12">
        <template>
          <b-card-code style="background-color:rgba(255,255,255, 0.9);">
            <b-row>
              <b-col
                md="3"
                class="d-flex align-items-center justify-content-end"
              >
                <label style="padding-right:14px; font-size: 15px">From</label>
                <b-form-group style="padding-right:14px">
                  <flat-pickr
                    v-model="date.dateFrom"
                    class="form-control"
                    @input="getHistory"
                  />
                </b-form-group>
                <label style="padding-right:14px; font-size: 15px">To</label>
                <b-form-group>
                  <flat-pickr
                    v-model="date.dateTo"
                    class="form-control"
                    @input="getHistory"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="4"
                class="text-sm-right mb-1"
              >
                <!-- <b-button
                  id="toggle-btn"
                  v-b-modal="'modalAdd'"
                  variant="primary"
                >
                  Add New
                </b-button> -->
              </b-col>
              <b-col
                md="4"
                class="d-flex align-items-center justify-content-start mb-1"
              >
                <label>Search</label>
                <b-input-group
                  size="sm"
                  style="padding-left:14px;"
                >
                  <b-form-input
                    id="filterInput"
                    v-model="filter"
                    type="search"
                    placeholder="Type to Search"
                    label-cols-sm="12"
                    label-cols-md="2"
                    label-cols-lg="2"
                    style="background-color:rgba(255,255,255, 0.9);"
                  />
                  <b-input-group-append>
                    <b-button
                      :disabled="!filter"
                      @click="filter = ''"
                    >
                      Clear
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
              <b-col
                md="1"
                class="text-sm-right mb-1"
              >
                <!-- <b-button
                  id="toggle-btn"
                  size="sm"
                  variant="warning"
                  @click="$refs.childref.getHistory(date)"
                >Report <feather-icon
                  class="text-light"
                  icon="ArrowDownIcon"
                  size="18"
                />
                </b-button> -->
                <b-button
                  id="toggle-btn"
                  v-b-modal="'modalReport'"
                  size="sm"
                  variant="primary"
                  @click="$refs.childref.getHistory(date)"
                >
                  Export PDF
                </b-button>
              </b-col>
              <b-col cols="12">
                <b-table
                  id="table"
                  responsive
                  :per-page="perPage"
                  :current-page="currentPage"
                  :items="items"
                  :fields="fields"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                />
              </b-col>

              <b-col
                cols="12"
              >
                <b-card-body class="d-flex justify-content-between flex-wrap pt-1">

                  <!-- page length -->
                  <b-form-group
                    label="Per Page"
                    label-cols="6"
                    label-align="left"
                    label-size="sm"
                    label-for="sortBySelect"
                    class="text-nowrap mb-md-0 mr-1"
                  >
                    <b-form-select
                      id="perPageSelect"
                      v-model="perPage"
                      size="sm"
                      inline
                      :options="pageOptions"
                      style="background-color:rgba(255,255,255, 0.9);"
                    />
                  </b-form-group>

                  <!-- pagination -->
                  <div>
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      first-number
                      last-number
                      prev-class="prev-item"
                      next-class="next-item"
                      class="mb-0"
                    >
                      <template #prev-text>
                        <feather-icon
                          icon="ChevronLeftIcon"
                          size="18"
                        />
                      </template>
                      <template #next-text>
                        <feather-icon
                          icon="ChevronRightIcon"
                          size="18"
                        />
                      </template>
                    </b-pagination>
                  </div>
                </b-card-body>
              </b-col>
            </b-row>
          </b-card-code>
        </template>
      </b-col>
    </b-row>
    <Report
      ref="childref"
      style="font-size: 20px;"
    />
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  BRow, BCol, BTable, BFormGroup,
  BFormSelect, BPagination, BCardBody,
  BButton, BInputGroupAppend, BInputGroup, BFormInput, VBModal,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import html2PDF from 'jspdf-html2canvas'
import Ripple from 'vue-ripple-directive'
// import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue'
import 'leaflet/dist/leaflet.css'
import axios from '@axios'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import Report from './Report.vue'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BFormGroup,
    BFormSelect,
    BPagination,
    BCardBody,
    BButton,
    BInputGroupAppend,
    BInputGroup,
    BFormInput,
    BCardCode,
    flatPickr,
    Report,
    // StatisticCardHorizontal,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      revenueGenerated: {},
      url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png',
      attribution: '',
      zoom: 12,
      center: [18.839867, 98.973773],
      markersSpeaker: [],
      markers: [],
      items: [],
      date: {
        dateFrom: '',
        dateTo: '',
      },
      fields: [
        // { key: 'edit', label: 'Edit', class: 'text-center' },
        {
          key: 'date_time', label: 'Date Time', sortable: true, class: 'text-center',
        },
        {
          key: 'system_name', label: 'System', sortable: true, class: 'text-center',
        },
        {
          key: 'devid', label: 'Devid', sortable: true, class: 'text-center',
        },
        {
          key: 'reason', label: 'Reason', sortable: true, class: 'text-left',
        },
        {
          key: 'building', label: 'Building', sortable: true, class: 'text-center',
        },
        // { key: 'delete', label: 'Delete', class: 'text-center' },
      ],
      Total: '',
      Online: '',
      Offline: '',
      // --------history--------
      perPage: 25,
      pageOptions: [25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      connect: [{
        Offline: 'non-connect', Online: 'connect',
      },
      {
        Offline: 'light-danger', Online: 'light-success',
      }],
      status: [{
        Offline: 'Offline', Online: 'Online', Trip: 'Trip',
      },
      {
        Offline: 'danger', Online: 'success', Trip: 'warning',
      }],
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    computedFields() {
      // If the user isn't an admin, filter out fields that require auth.
      if (this.userData.role === 'User') return this.fields.filter(field => !field.requiresAdmin)
      // If the user IS an admin, return all fields.
      return this.fields
    },
  },
  created() {
    setInterval(() => {
      this.getHistory()
    }, 7000)
  },
  mounted() {
    this.getHistory()
    this.setToday()
  },
  methods: {
    generatePDF() {
      const page = document.getElementById('table')
      html2PDF(page, {
        jsPDF: {
          format: 'a4',
        },
        margin: {
          top: 20,
          right: 20,
          bottom: 20,
          left: 20,
        },
        imageType: 'image/jpeg',
        output: 'generate.pdf',
      })
    },
    setToday() {
      const p = new Date()
      const month = (`0${p.getMonth() + 1}`).slice(-2)
      const date = 1
      const year = p.getFullYear()
      this.date.dateFrom = `${year}-${month}-${date}`
      this.date.dateTo = new Date().toJSON().slice(0, 10).replace(/-/g, '-')
    },
    getHistory() {
      axios
        .post('/get_historyNPT', this.date)
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length
        })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>

<style scoped lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';

.table-responsive{
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}
.table th{
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
.table td{
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
.vue2leaflet-map{
  &.leaflet-container{
    height: 325px;
  }
}
.leaflet-popup-content {
  margin: 10px 10px;
}
.leaflet-container a.leaflet-popup-close-button {
  padding: 0 0 0 0
}
</style>
